// src/pages/Dashboard/Admin/DetailsAdherents/components/AdherentQuickNav.jsx

import React from "react";
import {
  FaAddressCard,
  FaCalendarCheck,
  FaClipboardList,
  FaFileAlt,
  FaMedal,
  FaMoneyCheckAlt,
  FaTrophy,
  FaUserCog,
  FaUsers,
} from "react-icons/fa";

const LINKS = [
  { id: "identity", label: "Identité", icon: <FaAddressCard /> },
  { id: "groups", label: "Groupes", icon: <FaUsers /> },
  { id: "managers", label: "Gestionnaires", icon: <FaUserCog /> },
  { id: "dossier", label: "Dossier", icon: <FaFileAlt /> },
  { id: "reglement", label: "Règlement", icon: <FaClipboardList /> },
  { id: "belts", label: "Ceintures", icon: <FaMedal /> },
  { id: "competitions", label: "Compétitions", icon: <FaTrophy /> },
  { id: "palmares", label: "Palmarès", icon: <FaMedal /> },
  { id: "achats", label: "Achats", icon: <FaMoneyCheckAlt /> },
  { id: "attendance", label: "Présences", icon: <FaCalendarCheck /> },
];

export default function AdherentQuickNav() {
  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    const offset = 120;
    const top = element.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top, behavior: "smooth" });
  };

  return (
    <nav className="sticky top-3 z-40 overflow-hidden rounded-[24px] border border-slate-200 bg-white/90 p-2 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-900/90">
      <div className="flex gap-2 overflow-x-auto">
        {LINKS.map((link) => (
          <button
            key={link.id}
            type="button"
            onClick={() => scrollTo(link.id)}
            className="inline-flex shrink-0 items-center gap-2 rounded-2xl px-3 py-2 text-xs font-semibold text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-700 dark:text-slate-200 dark:hover:bg-indigo-500/10 dark:hover:text-indigo-300"
          >
            {link.icon}
            {link.label}
          </button>
        ))}
      </div>
    </nav>
  );
}